import { Heading3 } from '@lightspeed/flame/Text';
import { Box, Flex } from '@lightspeed/flame/Core';
import { LabelRequired } from '../custom/LabelRequired';
import { Autocomplete } from '../fields';
import { useTranslation } from 'react-i18next';
import useAccounts from '../../hooks/useAccounts';
import useIsInputsOnlyLayout from '../../hooks/useIsInputsOnlyLayout';

export const Series = () => {
  const [isLoading, accountsList] = useAccounts('giftCard');
  const { t } = useTranslation();
  const [isInputsOnlyLayout] = useIsInputsOnlyLayout();

  return <Box padding="0.75rem">
    <Heading3 mb="0.375rem">Series</Heading3>
    <Flex>
      <Box width="49%" pr="1.1rem">
        <LabelRequired htmlFor="Series">
          {
            t(isInputsOnlyLayout ? 'Enter Series account' : 'Select a Series account')
          } 
        </LabelRequired>
        <Autocomplete
          isLoadingOptions={isLoading}
          id="seriesAccount"
          name="seriesAccount"
          options={accountsList}
          placeholder={
            t(isInputsOnlyLayout ? 'Enter Series account' : 'Select an account')
          }
        />
      </Box>
    </Flex>
  </Box>;
};
